<template>
  <div class="footer">
    <div class="form_wrapper">
      <div class="title">Sign up for our monthly newsletter:</div>
      <a-form class="form" :model="formState" name="basic" autocomplete="off">
        <a-form-item name="firstname">
          <a-input placeholder="first name" v-model:value="formState.firstName" />
        </a-form-item>
        <a-form-item name="lastname">
          <a-input placeholder="last name" v-model:value="formState.lastName" />
        </a-form-item>
        <a-form-item name="email">
          <a-input placeholder="email" v-model:value="formState.email" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="submit_btn" @click="handleSubmitSubscriber()">Submit</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="nav_wrapper">
      <a href="" @click.prevent="linkToIndex" class="logo">
        <img src="@/assets/images/logo.svg" alt="Logo" class="logo" />
      </a>
      <div class="right_wrapper">
        <router-link to="/ourwork" class="link">
          Ourwork
        </router-link>
        <router-link to="/news" class="link">
          News & Stories
        </router-link>
        <router-link to="/aboutUs" class="link">
          About Us
        </router-link>
        <router-link to="/partnerships" class="link">
          Partnerships
        </router-link>
      </div>
    </div>
    <a-divider class="footer_divider" />
    <div class="link_wrapper">
      <div class="left_wrapper">
        <div class="contact">
          <span class="tag"></span>
          Contact Us
        </div>
        <div>
          <span class="contact_item">
            <img src="@/assets/images/email.svg" alt="email" />
            office@gffglobalmissions.org
          </span>
          <span class="contact_item">
            <img src="@/assets/images/phone.svg" alt="phone" />
            909-210-8623
          </span>
        </div>
      </div>
      <div class="right_wrapper">
        <div class="link_item">
          <!-- <a href="#" class="link">
            User Agreement
          </a>
          <a href="#" class="link">
            Privacy Policy
          </a>
          <a href="#" class="link">
            Cookie Policy
          </a> -->
          <a class="link">&nbsp;</a>
        </div>
        <p class="copyright">© 2026 Gleaning Fields Foundation, Inc. All rights reserved.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue';
import { defineComponent, onMounted, ref, computed, toRaw, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { submitSubscriber } from '@/api/common.js';

const route = useRoute();
const router = useRouter();
const isHome = computed(() => route.path === '/index');

const formState = reactive({
  firstName: '',
  lastName: '',
  email: '',
});

const openLink = (url) => {
  window.open(url, '_blank');
};

const linkToIndex = () => {
  if (isHome.value) {
    window.location.reload();
  } else {
    router.push('/index');
  }
};

const handleSubmitSubscriber = () => {
  submitSubscriber(toRaw(formState)).then((res) => {
    if (res.code == 200) {
      message.success(res.msg);
      formState.firstName = '';
      formState.lastName = '';
      formState.email = '';
    } else {
      message.error(res.msg);
    }
  });
};
</script>

<style lang="less" scoped>
.footer {
  .form_wrapper {
    background: #f78335;
    display: flex;
    justify-content: center;
    .title {
      padding: 20px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: #ffffff;
    }
    .form {
      background: #f99c5d;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 20px;
      gap: 24px;
      .ant-form-item {
        margin-bottom: 0;
        width: 134px;
        .ant-input {
          height: 40px;
          border-radius: 6px;
          border: none;
        }
        .submit_btn {
          height: 40px;
          border-radius: 6px;
          opacity: 1;
          background: linear-gradient(180deg, #f78335 0%, #ca0c0c 100%);
          box-sizing: border-box;
          border: 1px solid #ffd0aa;
          width: 134px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .form_wrapper {
      display: block;
      .title {
        justify-content: center;
      }
      .form {
        flex-wrap: wrap;
        .ant-form-item {
          width: calc(50% - 12px);
          .ant-input {
            width: 100%;
          }
        }
      }
    }
  }
  .nav_wrapper {
    padding: 12px 30px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    max-width: 1280px;
    .logo {
      float: left;
      margin-top: 5px;
      width: 240px;
      height: auto;
      cursor: pointer;
    }
    .right_wrapper {
      float: right;
      .link {
        color: #333333;
        font-size: 14px;
        text-decoration: none;
        line-height: 50px;
        margin: 0 16px;
        cursor: pointer;
        .link_icon {
          margin-right: 5px;
          &.icon_smile {
            width: 24px;
            height: 24px;
            vertical-align: middle;
          }
          &.icon_user {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
        }
      }
    }
  }
  @media (max-width: 1080px) {
    .nav_wrapper {
      text-align: center;
      .logo {
        display: none;
      }
      .right_wrapper {
        float: none;
        .link {
          line-height: 32px;
        }
      }
    }
  }
  .footer_divider {
    margin: 0 0 12px;
  }
  .link_wrapper {
    padding: 10px 30px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    max-width: 1280px;
    display: flex;
    justify-content: space-between;
    .left_wrapper {
      .contact {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
        .tag {
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #f78335;
          margin-right: 8px;
        }
      }
      .contact_item {
        margin-right: 24px;
        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 8px;
        }
      }
    }
    .right_wrapper {
      .link_item {
        margin-bottom: 16px;
        .link {
          margin-right: 16px;
          color: #333333;
          text-decoration: none;
          line-height: 24px;
          cursor: pointer;
        }
        .copyright {
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .link_wrapper {
      .left_wrapper {
        .contact_item {
          display: block;
          margin-bottom: 12px;
          width: 100%;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
